import fetch from "../utils/fetch";

//设置与编辑收银账户
export const fetchEditCapitalAccount = body =>
  fetch(`paymentAccount/receive`, {
    method: "post",
    body
  });

//查询收银账户信息
export const fetchAccountInfo = () => fetch(`paymentAccount/receive`);

//商户账户列表
export const fetchBusinessList = ({ type, companyName, pageSize, pageNum }) =>
  fetch(
    `paymentAccount/customerList?type=${type}&companyName=${companyName}&pageSize=${pageSize}&pageNum=${pageNum}`
  );

//分账绑定
export const fetchRoutingBind = body =>
  fetch(`paymentAccount/bind`, {
    method: "put",
    body
  });

//分账解绑
export const fetchRoutingUnbind = body =>
  fetch(`paymentAccount/unBind`, {
    method: "put",
    body
  });

//更新的接口
//支付宝分账商户列表
export const fetchAliPayList = ({ type, companyName, pageSize, pageNum }) =>
  fetch(
    `paymentAccount/aliPay/list?type=${type}&companyName=${companyName}&pageSize=${pageSize}&pageNum=${pageNum}`
  );

//支付宝商户分账绑定
export const fetchAliPayBind = body =>
  fetch(`paymentAccount/aliPay/bind`, {
    method: "put",
    body
  });

//支付宝分账解绑
export const fetchAliPayUnBind = body =>
  fetch(`paymentAccount/aliPay/unBind`, {
    method: "put",
    body
  });

//微信分账商户列表
export const fetchWeChatList = ({ companyName, pageSize, pageNum }) =>
  fetch(
    `paymentAccount/weChat/list?companyName=${companyName}&pageSize=${pageSize}&pageNum=${pageNum}`
  );

//微信分账商户详情
export const fetchWeChatDetail = ({ companyId }) =>
  fetch(`paymentAccount/weChat/details/${companyId}`);

//微信分账绑定/解绑
export const fetchWeChatBind = body =>
  fetch(`paymentAccount/weChat/bind`, {
    method: "put",
    body
  });
